module.exports = __webpack_public_path__ + "static/kamilemail-3dfd60c28606dceb58d69660bb6233c4.png";